import styled from '../../common/styled';

export default styled('a')`
	color: ${(props) => props.theme.typography.color_1};
`;
